import React from "react";

function WorkloadReadiness() {
  return (
    <div style={{ padding: "40px", textAlign: "center" }}>
      <h1>Workload Readiness</h1>
      <p style={{ color: "gray" }}>Content for Workload Readiness will be added soon.</p>
    </div>
  );
}

export default WorkloadReadiness;
